let url = {
    //改Url维版本维护页面的url。使用处：version-miantenance.vue  login.vue   Full.vue
    versionMaintenanceUrl: `mdm-common/acs/home/system-maintenance`
}
export default url


// WEBPACK FOOTER //
// ./src/url.js